import { Box } from '@material-ui/core';
import { FunctionComponent } from 'react';
import { useNavigate } from 'react-router';
import { ArrowBack } from '@material-ui/icons';
import i18n from 'i18n';
import passwordResetStyles from '../styles';

const BackToLogin: FunctionComponent = () => {
  const classes = passwordResetStyles();

  const navigate = useNavigate();

  const onCancel = () => {
    navigate('/signin');
  };

  return (
    <Box className={classes.backToLogin} onClick={onCancel}>
      <ArrowBack />
      {i18n.t('pages.passwordReset.typography.toLogin')}
    </Box>
  );
};

export default BackToLogin;
